import * as React from 'react';

interface LockIconProps
{
    className?:string,
    isLocked:boolean,
}

const LockIcon = (props:LockIconProps) => (
    <svg
        viewBox="0 0 24 24"
        className={props.className}
    >
        {
            props.isLocked &&
            <path
                fill="currentColor"
                d="M17 10h-1V8c0-2.206-1.794-4-4-4S8 5.794 8 8v2H7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-7-2c0-1.103.897-2 2-2s2 .897 2 2v2h-4V8z"
            />
        }
        {
            !props.isLocked &&
            <path
                fill="currentColor"
                d="M8 10h6V8c0-1.103-.897-2-2-2s-2 .897-2 2H8c0-2.206 1.794-4 4-4s4 1.794 4 4v2h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1zm8 2H7.998v4H16v-4z"
            />
        }
    </svg>
);

export default LockIcon;
